export default __webpack_public_path__ + "static/media/IMG-20241005-WA0038.3ea7b715.jpg";